import _ from 'underscore';
import ko from 'knockout';
import { FilterSchema } from '@bingads-webui/filter-schema';
import { FilterI18n } from '@bingads-webui/filter-i18n';
import { PredicateVM } from './predicate';

// TODO: [yaoyao] [wewei] we need general support for multi-level menu;
// Bug #547217 filed to track this;
const biPattern = /^(Phone)?PerformanceMetrics\//;
const biPoPPattern = /^PoP(Phone)?PerformanceMetrics/;

const noDuplicateFilter = ['ChangeHistoryDetail', 'ReportingUI'];

export class PredicatesListVM {
  constructor(options) {
    this.options = options;
    this.maxConditionCount = this.options.maxConditionCount || 5;

    this.filterSchema = new FilterSchema(this.options.entitySchema);
    // this._i18nConverter = new FilterI18n(this._schema,
    //  _.pick(this.options, 'shortDateFormat', 'i18n_prefixes'));
    this.i18nConverter = new FilterI18n(this.filterSchema, options.i18n);
    this.i18n = options.i18n;

    this.items = ko.observableArray();
    this.errors = ko.observableArray();

    this.isComparingEnabled = this.options.isComparingEnabled || false;
    this.biProperties = [];
    this.nonBiProperties = [];
    this.buildPropertiesArray();

    this.canAddItem = ko.computed(this.canAddItemCheck, this);

    this.removeItem = this.items.remove.bind(this.items);
    this.canApply = ko.computed(this.validate, this).extend({ notify: 'always' });
    this.onChange = ko.computed(this.listenToChange, this).extend({ notify: 'always' });

    this.setPredicates(this.options.predicates);
  }

  newItem() {
    const firstProperty = this.filterSchema.getPropertyKeys()[0];
    // metadata = this._schema.getProperty(firstProperty)
    const metadata = this.filterSchema.getFilterProperty(firstProperty);
    const newItem = this.createItem(firstProperty, metadata.operators[0]);

    this.items.push(newItem);

    return this;
  }


  canAddItemCheck() {
    return this.items().length < this.maxConditionCount &&
      (this.biProperties.length > 1 || this.nonBiProperties.length > 1);
  }

  listenToChange() {
    _.each(this.items(), (item) => {
      item.propertyValue();
      item.operator();
      item.getExpressionValue();
    });
  }

  validate() {
    this.errors.removeAll();

    if (this.items().length > 0) {
      if (this.filterSchema && _.contains(noDuplicateFilter, this.filterSchema.entityName)) {
        const uniqueTexts = [];
        const duplicates = [];
        _.each(this.items(), (item) => {
          const propertyText = item.propertyText();
          if (_.contains(uniqueTexts, propertyText)) {
            duplicates.push(propertyText);
          } else {
            uniqueTexts.push(propertyText);
          }
        });

        if (duplicates.length > 0) {
          this.errors.push(this.i18n.getString('Filter_Cannot_Have_Duplicate', { duplicate: _.first(duplicates) }));

          return false;
        }
      }

      return _.every(this.items(), item => item.isValueExists() && item.validationResult().isValid);
    }
    return false;
  }

  setPredicates(predicates) {
    this.items(_.map(predicates, this.expressionToItem.bind(this)));
    if (_.isEmpty(this.items())) {
      this.newItem();
    }
    return this;
  }

  getPredicates() {
    const items = this.items();
    if (items.length === 0) {
      return [];
    }

    return _.chain(items)
      .map(item => item.getExpression())
      .reject(_.isNull)
      .map(expr => _.object([expr.property], [_.object([`$${expr.operator}`], [expr.value])]))
      .value();
  }

  showValidationErrors() {
    _.each(this.items(), (item) => {
      item.valueChanged(true);
    });
  }

  /**
   * Converts an expression into an item
   * @param {Object} filter - the filter
   * @returns {Object} a new item
   */
  expressionToItem(filter) {
    const property = _.keys(filter)[0];
    const predicate = filter[property];
    const operator = _.keys(predicate)[0];
    // in some senario the values for enum is actually like
    // [['Eligible','BudgetSuggestions']] (found in campaign migration)
    // this senario will not check the right selected ones by
    // _.values(predicate), it also need _.values(predicate)[0]
    const values = this.filterSchema.getFilterProperty(property).enum &&
      !_.isArray(_.values(predicate)) ? _.values(predicate) : _.values(predicate)[0];

    return this.createItem(property, operator, values);
  }

  /**
   * Creates an item
   * @private
   * @param {Object} property - the property
   * @param {Object} operator - the operator
   * @param {Object} value - the value
   * @returns {Object} the item
   */
  createItem(property, operator, value) {
    return new PredicateVM(_.extend({}, this.options, {
      propertyValue: property,
      propertyText: this.i18nConverter.convertName(property),
      operator: operator ? operator.replace(/^\$/, '') : operator,
      value,
      filterSchema: this.filterSchema,
      i18nConverter: this.i18nConverter,
    }));
  }

  buildPropertiesArray() {
    _.each(this.filterSchema.getPropertyKeys(), (key) => {
      const propertyPath = this.filterSchema.entitySchema.properties[key].property ||
        this.filterSchema.entitySchema.properties[key].field;

      if (biPattern.test(propertyPath)) {
        if (this.isComparingEnabled && !!this.filterSchema.entitySchema.properties[`PoP${key}`]) {
          this.biProperties.push([{
            name: key,
            localized: this.i18nConverter.convertName(key),
          }, {
            name: `PoP${key}`,
            localized: this.i18nConverter.convertName(`PoP${key}`),
          }, {
            name: `PoP${key}Change`,
            localized: this.i18nConverter.convertName(`PoP${key}Change`),
          }, {
            name: `PoP${key}ChangePercent`,
            localized: this.i18nConverter.convertName(`PoP${key}ChangePercent`),
          }]);
        } else {
          this.biProperties.push({
            name: key,
            localized: this.i18nConverter.convertName(key),
          });
        }
      } else if (!biPoPPattern.test(propertyPath)) {
        this.nonBiProperties.push({
          name: key,
          localized: this.i18nConverter.convertName(key),
        });
      }
    });
  }
}
